import i18n, { i18n_t } from '@/locales/i18n';
import SMHErrorCodeMap from './smhErrorCodeMap';
import NodeErrorCodeMap from './nodeErrorCodeMap';
import CustomErrorCodeMap from './customErrorCodeMap';
type RequestError = {
  code?: string;
  Code?: string;
  inner?: string;
  message?: string;
  Message?: string;
  interface?: string;
  error?: {
    code?: string;
    Code?: string;
    message?: string;
    Message?: string;
  };
};

/**
 * 错误码集合
 */
const errorCodeMap = {
  ...SMHErrorCodeMap,
  ...NodeErrorCodeMap,
  ...CustomErrorCodeMap,
};

/**
 * @description 错误码格式化提示
 * @param {(string | RequestError)} error
 * @return string
 */
export function formatError(error: string | RequestError, disableLogger?: boolean, fallbackMessage?: string): string {
  let formatCode = '';
  let formatError = {
    code: '',
    message: '',
  };
  if (typeof error === 'string') {
    try {
      const parsedError = JSON.parse(error);
      const errCode = parsedError.code || parsedError.Code || parsedError?.error?.code || parsedError?.error?.Code;
      const errMessage =
        parsedError.message || parsedError.Message || parsedError?.error?.message || parsedError?.error?.Message;
      formatError = parsedError;
      if (errCode) {
        formatCode = errorCodeMap[errCode] || fallbackMessage || i18n_t('未知错误');
      } else if (errMessage) {
        formatCode = errMessage;
      }
    } catch (e) {
      formatError = {
        code: error,
        message: error,
      };
      formatCode = errorCodeMap[error] || error;
    }
  } else {
    const errCode = error.code || error.Code || error?.error?.code || error?.error?.Code;
    const errMessage = error.message || error.Message || error?.error?.message || error?.error?.Message;
    const errInterface = error.interface;
    if (errCode) {
      // 存在user-api调用api时报错SmartMediaHostingError，此时错误码为inner对应字段
      const code = errCode === 'SmartMediaHostingError' && error.inner ? error.inner : errCode;
      formatError = {
        code,
        message: errMessage || '',
      };
      formatCode = errorCodeMap[code] || code;
    } else if (errMessage) {
      formatCode = errMessage;
      formatError = {
        code: errMessage,
        message: errMessage || '',
      };
    } else if (errInterface) {
      formatCode =
        errorCodeMap[errInterface] ||
        i18n_t('{errInterface}错误', {
          errInterface,
        });
      formatError = {
        code: errInterface,
        message: formatCode || '',
      };
    } else {
      formatCode = JSON.stringify(error);
      formatError = error as any;
    }
    if (formatCode === 'Network Error') {
      formatCode = i18n_t('当前无网络，请连接网络后重试');
    }
  }
  /* i18n-ignore*/
  !disableLogger && logger.smh.error(logger.smh.error('错误提示信息===:', JSON.stringify(formatError))); // 错误信息记入日志

  return formatCode;
}
export default errorCodeMap;
